import addressHelpers from '../helpers/address'

export default {
    methods: addressHelpers
}
